/* global axios */

export const fetchWhatsAppProfile = async (accountId, inboxId) => {
  const response = await axios.get(
    `/api/v1/accounts/${accountId}/inboxes/${inboxId}/whatsapp/profile`
  );
  return response.data;
};

export const updateWhatsAppProfile = async (
  accountId,
  inboxId,
  profileData
) => {
  const formData = new FormData();

  Object.keys(profileData).forEach(key => {
    if (key === 'profile_picture' && profileData[key]) {
      formData.append('profile_picture', profileData[key]);
    } else if (profileData[key] !== undefined && profileData[key] !== null) {
      formData.append(key, profileData[key]);
    }
  });

  const response = await axios.put(
    `/api/v1/accounts/${accountId}/inboxes/${inboxId}/whatsapp/profile`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};
